import { render, staticRenderFns } from "./LearningCenter.vue?vue&type=template&id=fc79544a&"
import script from "./LearningCenter.vue?vue&type=script&lang=js&"
export * from "./LearningCenter.vue?vue&type=script&lang=js&"
import style0 from "./LearningCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports